import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OuiSnackbarService } from 'omnium-ui/snackbar';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

// Le token est ajouté par le MsalInterceptor (permissionsMap de provideFinzzleAuth) ;
// cet intercepteur ne fait que signaler les refus de l'API.
export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const snackbarService = inject(OuiSnackbarService);

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && request.url.startsWith(environment.apiBaseUrl.replace(/\/$/, ''))) {
        snackbarService.open("L'API a refusé l'authentification. Reconnectez-vous pour continuer.", 'error');
      }

      return throwError(() => error);
    })
  );
};
